import React from 'react';
import c from 'classnames';

interface Props {
    campaignId: string;
    campaignSource?: string;
    offsetBottom?: 4 | 10;
    className?: string;
}

export default function PoweredBy({ campaignId, campaignSource = '', offsetBottom = 4, className }: Props) {
    return (
        <div
            className={c(
                `absolute -bottom-${offsetBottom} right-4 mb-1 rounded-md border bg-white px-2 py-1 align-middle text-xs font-medium text-gray-600 backdrop-blur-lg`,
                className
            )}
        >
            <a
                href={`https://www.pricewell.com/?utm_source=${['poweredby', campaignSource].join(
                    '-'
                )}&utm_medium=web&utm_campaign=${campaignId}`}
                className="text-xs text-gray-800 font-light hover:underline"
                rel="noopener noreferrer"
                style={{ fontFamily: '"Source Sans Pro", "Arial", sans-serif' }}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlSpace="preserve"
                    viewBox="0 0 59.998 59.998"
                    className="inline w-4 mr-1 align-bottom"
                >
                    <path d="M59.206.293a.999.999 0 0 0-1.414 0L54.085 4H30.802L1.532 33.511c-.666.666-1.033 1.553-1.033 2.495s.367 1.829 1.033 2.495l20.466 20.466a3.51 3.51 0 0 0 2.491 1.031 3.54 3.54 0 0 0 2.509-1.041l28.501-29.271V5.414l3.707-3.707a.999.999 0 0 0 0-1.414zm-5.707 28.581L25.574 57.553a1.53 1.53 0 0 1-2.162 0L2.946 37.087a1.532 1.532 0 0 1 .003-2.165L31.636 6h20.449l-4.833 4.833A4.969 4.969 0 0 0 44.499 10c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5a4.969 4.969 0 0 0-.833-2.753l4.833-4.833v21.46zm-6-13.874c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3c.462 0 .894.114 1.285.301l-1.992 1.992a.999.999 0 1 0 1.414 1.414l1.992-1.992c.188.391.301.823.301 1.285z" />
                </svg>
                Powered By PriceWell
            </a>
        </div>
    );
}
